import type { DeduplicationKind } from '../config'

export const observerPath = (kind: DeduplicationKind, search?: string) =>
  search
    ? `/de-duplication/${kind === 'company' ? 'companies' : 'contacts'}${search}`
    : `/de-duplication/${kind === 'company' ? 'companies' : 'contacts'}`

const kindSegment = (kind: DeduplicationKind) => (kind === 'company' ? 'companies' : 'contacts')

export const groupDetailPath = (kind: DeduplicationKind, runId: string, groupTraceId: string) =>
  `/de-duplication/${kindSegment(kind)}/runs/${runId}/groups/${groupTraceId}`

export const runDetailPath = (kind: DeduplicationKind, runId: string, tab?: string) => {
  const base = `/de-duplication/${kindSegment(kind)}/runs/${runId}`
  if (!tab || tab === 'groups') {
    return base
  }
  return `${base}?tab=${tab}`
}
